import React from "react";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { loginRequest } from '../../_helpers/authConfig';
import { BoxArrowRight, BoxArrowInRight } from 'react-bootstrap-icons';

import { Nav, Navbar, Container } from "react-bootstrap";


const Header = (props) => {

  const { instance } = useMsal();

  const handleLoginRedirect = () => {
      instance.loginRedirect(loginRequest).catch((error) => console.log(error));
  };

  const handleLogoutRedirect = () => {
      instance.logoutRedirect().catch((error) => console.log(error));
  };
  
  return (
    <Navbar id="navbar" bg="light" expand="lg" className="mb-4">
      <Container>
        <Navbar.Brand href="/">
          backupkontrolle.ch
        </Navbar.Brand>
        <AuthenticatedTemplate>
          <Nav className="mr-auto">
            {/* <Nav.Link href="/dashboard">Dashboard</Nav.Link> */}
            <Nav.Link href="/backupitems">Backup Items</Nav.Link>
            <Nav.Link href="/mails">Mails</Nav.Link>
            <Nav.Link href="/tools">Tools</Nav.Link>
          </Nav>
        </AuthenticatedTemplate>
        <Navbar.Collapse className="justify-content-end">
          <AuthenticatedTemplate>
            <Nav.Link onClick={handleLogoutRedirect} style={{ cursor: 'pointer' }} title="Sign Out">
              <BoxArrowRight size={20} />
            </Nav.Link>
          </AuthenticatedTemplate>
          <UnauthenticatedTemplate>
            <Nav.Link onClick={handleLoginRedirect} style={{ cursor: 'pointer' }} title="Sign In">
              <BoxArrowInRight size={20} />
            </Nav.Link>
          </UnauthenticatedTemplate>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;